import { FocusMonitor } from '@angular/cdk/a11y';
import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[nebulaAutofocus]'
})
export class NebulaAutofocusDirective implements OnInit {

  constructor(private el: ElementRef, private monitor: FocusMonitor) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.monitor.focusVia(this.el, 'keyboard');
    });
  }

}
